<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-06 16:56:04
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-30 17:28:14
-->
<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-06 13:55:51
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-06 18:14:54
-->
<template>
  <div class="team-manage-container">
    <el-row>
      <el-col :span="7">
        <div class="list">
          <div class="list-search">
            <el-input v-model="params.keywords" :placeholder="$t('system::team::search')" clearable></el-input>
            <el-button type="primary" style="margin-left: 8px" @click="toAdd">
              {{ $t('system::team::add') }}
            </el-button>
          </div>
          <ScrollsBar style="height: 660px" ref="scroll">
            <ul class="role-list">
              <div
                class="all-select"
                :class="{ active: selectTreeItem && selectTreeItem.type == 0 }"
                @click="onItemClickAll"
              >
                {{ $t('system::team::all_select') }}
              </div>
              <el-tree
                ref="tree"
                label="name"
                :data="treeData"
                @node-click="onItemClick"
                :filter-node-method="filterNode"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node" :class="{ isEdit: data.edit }" slot-scope="{ node, data }">
                  <span class="input-item-wrap" @click.stop :class="{ error: data.error }" v-if="data.edit">
                    <el-input
                      @click.stop
                      v-model="data.name"
                      class="tree-input"
                      @keyup.native.enter="() => itemOk(data, node)"
                      size="small"
                    ></el-input>
                    <span class="error-item" :title="data.error">!</span>
                  </span>
                  <span v-else>{{ data.nameDefault }}</span>
                  <span class="ctl-tree" :class="{ noEdit: data.edit }">
                    <i v-if="data.loading" style="margin-right: 4px" class="el-icon-loading"></i>
                    <el-button
                      :data-level="node.level"
                      type="text"
                      v-if="node.level <= 2 && !data.edit"
                      size="mini"
                      @click.stop="() => append(data)"
                    >
                      <i class="iconadd2 iconfont"></i>
                    </el-button>
                    <el-button type="text" v-if="data.edit" size="mini" @click.stop="() => itemOk(data, node)">
                      <i class="iconqueding_queren iconfont"></i>
                    </el-button>
                    <el-button type="text" v-if="data.edit" size="mini" @click.stop="() => itemCancel(node, data)">
                      <i class="iconic-close1 iconfont"></i>
                    </el-button>
                    <el-button v-if="!data.edit" type="text" size="mini" @click.stop="() => editItem(node, data)">
                      <i class="iconedit1 iconfont"></i>
                    </el-button>
                    <el-button type="text" v-if="!data.edit" size="mini" @click.stop="() => delItem(node, data)">
                      <i class="icondelete1 iconfont"></i>
                    </el-button>
                  </span>
                </span>
              </el-tree>
            </ul>
          </ScrollsBar>
        </div>
      </el-col>
      <el-col :span="17">
        <div class="wrap">
          <div class="mb-16">
            <el-button :type="activeTab === 'team' ? 'primary' : ''" @click="changeType('team')">
              {{ selectTreeItem.id ? $t('system::team::staff') : $t('system::team::all_select') }}
            </el-button>
            <el-button
              v-if="
                (selectTreeItem.id && selectTreeItem && !selectTreeItem.children) ||
                (selectTreeItem.children && !selectTreeItem.children.length)
              "
              :type="activeTab === 'shop' ? 'primary' : ''"
              @click="changeType('shop')"
            >
              {{ $t('system::team::shop') }}
            </el-button>
          </div>
          <component
            :is="activeTab"
            :treeData="treeData"
            :selected="selectTreeItem"
            :ref="activeTab"
            @refresh="getRoleList(true)"
          ></component>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import team from './list.vue'
import shop from './shop.vue'
import { teamList, teamUpdate, teamItemDel } from '@/server/team-manage'
import { deepClone, setUid } from '@/utils'
export default {
  components: { team, shop },
  computed: {},
  data() {
    return {
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      activeTab: 'team',
      selectTreeItem: {
        type: 0,
      },

      loading: false,
      treeData: [],
      params: {
        keywords: '',
      },
      activeRole: {},
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    'params.keywords'(val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    async getList() {
      this.loading = true
      const { data } = await teamList({
        ...this.params,
        ...this.pagination,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.setTreeData(data.data.items)
        this.pagination.total = data.data.totalCount
      }
    },
    setTreeData(arr) {
      const fn = arr => {
        return arr.map(item => {
          item.edit = false
          item.error = ''
          item.nameDefault = item.name
          item.loading = false
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          }
          return item
        })
      }
      this.treeData = fn(arr)
      this.$refs.scroll && this.$refs.scroll.update()
    },

    changeType(val) {
      if (this.activeTab === val) {
        return
      }
      this.activeTab = val
    },
    changeRole(role) {
      if (this.activeRole.roleId === role.roleId) {
        return
      }
      this.activeRole = role
      this.$nextTick(() => {
        this.$refs[this.activeTab].search()
      })
    },
    onItemClick(data, node, el) {
      if (data.nameDefault) {
        this.activeTab = 'team'
        this.selectTreeItem = { ...data, type: 1 }
      }
    },
    onItemClickAll() {
      this.$refs.tree.setCurrentKey(null)
      // 0 所有员工 1，团队下员工
      this.selectTreeItem = {
        type: 0,
      }
    },
    append(data) {
      const newChild = {
        id: setUid(),
        name: '',
        children: [],
        edit: true,
        nameDefault: undefined,
        error: '',
        loading: false,
      }
      console.log(newChild, data)
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.unshift(newChild)
    },
    itemCancel(node, data) {
      if (!data.nameDefault) {
        this.delItem(node, data, 'cancel')
      } else {
        const fn = arr => {
          return arr.map(item => {
            if (data.id == item.id) {
              item.error = ''
              item.edit = !item.edit
              item.name = item.nameDefault
            } else if (item.children && item.children.length) {
              item.children = fn(item.children)
            }
            return item
          })
        }
        this.treeData = fn(this.treeData)
      }
    },
    async updateItemTeam(data, fn, errFn) {
      let info = deepClone(data)
      const params = {
        id: info.id,
        level: info.level - 1,
        parentId: info.parentId,
        name: info.name,
        team: info.team,
      }
      let obj = null

      if (!data.nameDefault) {
        delete params.id
      }
      const res = await teamUpdate({
        ...params,
      })
      if (res.data.code == this.$code) {
        if (!params.nameDefault) {
          obj = res.data.data
        }
        if (fn) fn(obj)
      } else {
        if (errFn) errFn()
      }
    },
    async delItemTeam(data, fn) {
      const res = await teamItemDel(data.id)
      if (res.data.code == this.$code) {
        if (this.selectTreeItem.id == data.id) {
          this.onItemClickAll()
        }
        if (fn) fn()
      }
    },
    itemOk(data, node) {
      const fn = arr => {
        return arr.map(item => {
          if (data.id == item.id) {
            if (!item.name) {
              item.error = this.$t('system::common::input_holder')
            } else {
              const parent = node.parent.data || {}
              item.loading = true
              const info = { ...data }
              info.parentId = parent.id || 0
              info.team = info.parentId == 0 ? undefined : !parent.team ? parent.id : parent.team
              info.level = node.level
              this.updateItemTeam(
                info,
                obj => {
                  // save 之后更新对象数据
                  if (obj) {
                    item.id = obj.id
                    item.team = obj.team
                  }
                  item.error = ''
                  item.level = node.level
                  item.parentId = node.parent && node.parent.id
                  item.loading = false
                  item.edit = !item.edit
                  item.nameDefault = item.name
                },
                () => {
                  item.loading = false
                }
              )
            }
          } else if (item.children && item.children.length) {
            item.children = fn(item.children)
          }
          return item
        })
      }
      this.treeData = fn(this.treeData)
    },
    editItem(node, data) {
      const fn = arr => {
        return arr.map(item => {
          if (data.id == item.id) {
            item.edit = !item.edit
          } else if (item.children && item.children.length) {
            item.children = fn(item.children)
          }
          return item
        })
      }
      this.treeData = fn(this.treeData)
    },
    delItem(node, data, type) {
      if (data.children && data.children.length) {
        this.$message.error(this.$t('system::team::有下级数据，无法删除'))
        return false
      }
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.id === data.id)
      if (type == 'cancel') {
        // children.splice(index, 1)
        const fn = arr => {
          console.log(
            arr.filter(item => item.id != data.id),
            data.id
          )
          return arr
            .filter(item => item.id != data.id)
            .map(item => {
              if (item.children && item.children.length) {
                item.children = fn(item.children)
              }
              return item
            })
        }
        this.treeData = fn(this.treeData)
      } else {
        this.delItemTeam(data, () => {
          children.splice(index, 1)
        })
      }
    },

    toAdd() {
      const newChild = {
        id: setUid(),
        level: 1,
        parentId: 0,
        name: '',
        children: [],
        team: undefined,
        edit: true,
        nameDefault: undefined,
        error: '',
        loading: false,
      }
      this.treeData.unshift(newChild)
    },
  },
}
</script>

<style lang="scss" scoped>
.team-manage-container {
  // display: flex;
  .tree-input {
    width: 120px;
  }
  .custom-tree-node {
    display: block;
    position: relative;
    box-sizing: border-box;
    width: 100%;
  }
  .all-select {
    padding: 0px 6px;
    line-height: 36px;
    height: 36px;
    cursor: pointer;
    &:hover {
      background-color: #f0f2f5;
    }
    &.active {
      background-color: #f0f2f5;
    }
  }

  .input-item-wrap {
    position: relative;
    .error-item {
      position: absolute;
      display: none;
      right: 0;
      padding: 4px;
      color: $--color-tip;
      top: -5px;
      line-height: 24px;
    }
    &.error {
      .error-item {
        display: block;
      }
    }
  }
  .ctl-tree {
    position: absolute;
    right: 8px;
    display: none;
    top: -5px;
    &.noEdit {
      top: 2px;
    }
  }
  .isEdit {
    .ctl-tree {
      display: block;
    }
  }
  .el-tree {
    /deep/ .is-current {
      & > .el-tree-node__content {
        background: rgba(54, 109, 255, 0.1) !important;
        color: #0560fd !important;
      }
    }
  }

  /deep/.el-tree-node__content {
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    &:hover {
      .ctl-tree {
        display: block;
      }
    }
  }
}
.el-icon-delete-solid,
.el-icon-edit {
  color: #999;
  cursor: pointer;
  display: none;
  margin-left: 16px;
}
.active {
  background: rgba(54, 109, 255, 0.1) !important;
  color: #0560fd !important;
  .num {
    color: #0560fd !important;
  }
}
.team-manage-container {
  .list {
    flex: 0 0 280px;
    height: 700px;
    border-radius: 6px;
    margin-right: 16px;
    background-color: #ffffff;
    padding: 24px;
    .list-search {
      margin-bottom: 16px;
      display: flex;
    }
    .role-list {
      .list-item {
        padding: 16px;
        background: #f4f4f4;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        .label {
          font-weight: bold;
          display: inline-block;
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .num {
          color: #999;
        }
      }
      .list-item + .list-item {
        margin-top: 16px;
      }
    }
    .list-item:hover {
      background: rgba(54, 109, 255, 0.1) !important;
      color: #0560fd !important;
      .num {
        color: #0560fd !important;
      }
      .el-icon-delete-solid,
      .el-icon-edit {
        display: inline-block;
      }
    }
  }
  .wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    .wrap-content {
      flex: 1;
      padding: 24px;
      background-color: #fff;
      border-radius: 6px;
    }
  }
}
</style>
